import { ReactNode } from 'react';
import { MarketModalFull } from '@market/react';
import X from '@square-icons/react/24/UI/x';
import useDelayedRender from '../hooks/use_delayed_render';
import styles from './mobile_modal.module.scss';

export interface MobileModalProps {
  isOpen: boolean;
  onClose: () => void;
  titleChild: ReactNode;
  navLinks: ReactNode[];
}

/**
 * Mobile modal layout component
 * Full-screen modal displaying navigation links
 */
const MobileModal = ({
  isOpen,
  onClose,
  titleChild,
  navLinks,
}: MobileModalProps) => {
  // Use delayed render to prevent flicker of the header on close
  // this is a TEMPORARY SOLUTION to an issue where the mobile header becomes unsticky when the modal is opened
  // and then flickers back into being sticky when the modal is closed
  // a small delay is added to the unmounting of the modal to prevent the flicker
  // this should be removed when the issue is fixed either when we migrate to @squareup/market-react or when we find a better solution
  const shouldRender = useDelayedRender(isOpen);

  if (!shouldRender) {
    return null;
  }

  return (
    <MarketModalFull
      className={styles.modal}
      data-cta-subnav-modal
      data-testid="cta-subnav-mobile-modal"
    >
      <div className={styles.modalHeader}>
        <div className={styles.modalTitleContainer}>{titleChild}</div>
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close"
          data-testid="cta-subnav-mobile-modal-close"
        >
          <X />
        </button>
      </div>
      <div className={styles.modalContent}>
        {navLinks.map((link, index) => (
          <div key={index} className={styles.modalNavItem}>
            {link}
          </div>
        ))}
      </div>
    </MarketModalFull>
  );
};

export default MobileModal;
